<template>
    <v-app class="min-h-screen">
        <v-app-bar
            app
            color="white"
            height="64"
            elevate-on-scroll
            :class="$vuetify.breakpoint.smAndUp ? 'px-6' : null"
        >
            <a href="https://musicologielessons.com">
                <jet-application-logo
                    class="block w-auto"
                    :class="$vuetify.breakpoint.xs ? 'h-6' : 'h-9'"
            /></a>
            <v-spacer />
            <div class="flex gap-2 justify-end">
                <v-btn
                    v-if="false"
                    outlined
                    href="/get-started"
                    color="primary"
                    class="white--text soli-round"
                    >Get Started</v-btn
                >
                <SoliBtn
                    gradient="gradient-orange"
                    href="/login"
                    class="white--text"
                    >Login</SoliBtn
                >
            </div>
        </v-app-bar>

        <v-main>
            <section id="hero">
                <v-row no-gutters>
                    <v-img
                        :min-height="
                            'calc(100vh - ' + $vuetify.application.top + 'px)'
                        "
                        src="instruments-blue-background.jpg"
                    >
                        <v-theme-provider dark>
                            <v-container fill-height>
                                <v-row
                                    align="center"
                                    class="white--text mx-auto"
                                    justify="center"
                                >
                                    <v-col
                                        class="white--text text-center"
                                        cols="12"
                                        tag="h1"
                                    >
                                        <div class="text-sm-h4 text-h5">
                                            Simply Delightful Booking
                                        </div>
                                        <div
                                            class="text-sm-h2 text-h3 font-weight-bold"
                                        >
                                            Schedule. Connect. Explore.
                                        </div>
                                    </v-col>

                                    <v-btn
                                        class="align-self-end mt-3"
                                        fab
                                        outlined
                                        @click="$vuetify.goTo('#about-me')"
                                    >
                                        <v-icon
                                            >keyboard_double_arrow_down</v-icon
                                        >
                                    </v-btn>
                                </v-row>
                            </v-container>
                        </v-theme-provider>
                    </v-img>
                </v-row>
            </section>

            <section id="about-me">
                <div class="py-12"></div>

                <v-container
                    :class="
                        $vuetify.breakpoint.smAndUp
                            ? 'text-start'
                            : 'text-center'
                    "
                    v-if="$vuetify.breakpoint.smAndUp"
                >
                    <v-row>
                        <v-col cols="4">
                            <v-img
                                class="mx-auto"
                                width="250"
                                src="App-Demo.gif"
                            />
                        </v-col>
                        <v-col cols="8" class="align-self-center">
                            <h2 class="text-h4 font-weight-bold mb-3">
                                We make scheduling easy
                            </h2>
                            <v-divider class="mb-3 soli-blue"></v-divider>
                            <div class="mx-auto text-h6 mb-4">
                                Sick kid? Reschedule with a few taps. Can't get
                                out of the house? Switch from in person to
                                online. Need a change of pace? Try a new
                                instrument. It takes just seconds.
                            </div>

                            <v-btn
                                color="dark"
                                href="https://musicologielessons.com/get-started"
                                outlined
                                large
                                class="soli-round float-left"
                            >
                                <span
                                    class="grey--text text--darken-1 font-weight-bold"
                                >
                                    Try your first lesson
                                </span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>

                <v-container class="text-start" v-if="$vuetify.breakpoint.xs">
                    <h2 class="display-2 font-weight-bold mb-3">
                        We make scheduling easy
                    </h2>
                    <v-divider class="mb-3 soli-blue"></v-divider>
                    <v-img
                        class="mx-auto my-6"
                        width="300"
                        src="App-Demo.gif"
                    />
                    <v-col>
                        <div class="mx-auto title font-weight-light mb-8">
                            Sick kid? Reschedule with a few taps. Can't get out
                            of the house? Switch from in person to online. Need
                            a change of pace? Try a new instrument. It takes
                            just seconds.
                        </div>
                        <div class="flex justify-center">
                            <v-btn
                                color="dark"
                                href="https://musicologielessons.com/get-started"
                                outlined
                                large
                                class="soli-round"
                            >
                                <span
                                    class="grey--text text--darken-1 font-weight-bold"
                                >
                                    Try your first lesson
                                </span>
                            </v-btn>
                        </div>
                    </v-col>
                </v-container>
                <div class="py-12"></div>
            </section>

            <section id="features" class="grey lighten-3">
                <div class="py-12"></div>

                <v-container class="text-center">
                    <h2 class="text-h3 font-weight-bold mb-3">Features</h2>
                    <div class="py-4" />

                    <v-row>
                        <v-col
                            v-for="({ icon, title, text }, i) in features"
                            :key="i"
                            cols="12"
                            md="4"
                        >
                            <v-card
                                class="py-12 px-4 soli-round"
                                color="grey lighten-5"
                                flat
                            >
                                <v-theme-provider dark>
                                    <div>
                                        <v-avatar color="primary" size="88">
                                            <v-icon
                                                large
                                                v-text="icon"
                                            ></v-icon>
                                        </v-avatar>
                                    </div>
                                </v-theme-provider>

                                <v-card-title
                                    class="justify-center font-weight-black text-uppercase"
                                    v-text="title"
                                ></v-card-title>

                                <v-card-text class="text-h6" v-text="text">
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>

                <div class="py-12"></div>
            </section>

            <section id="privacy">
                <div class="py-12"></div>
                <v-container class="text-center">
                    <h2 class="text-h4 font-weight-bold mb-3">
                        Privacy Matters
                    </h2>
                    <div class="text-h6 mb-4">
                        We'll never sell your data to 3rd parties
                    </div>

                    <v-row class="py-4 justify-center">
                        <v-btn
                            color="dark"
                            href="/privacy"
                            outlined
                            large
                            class="soli-round justify-center"
                        >
                            <span
                                class="grey--text text--darken-1 font-weight-bold"
                            >
                                Privacy Policy
                            </span>
                        </v-btn>
                    </v-row>
                </v-container>
                <div class="py-12"></div>
            </section>

            <section id="stripe" class="grey lighten-3">
                <div class="py-12"></div>
                <v-container>
                    <v-img
                        v-if="$vuetify.breakpoint.xs"
                        class="mx-auto"
                        width="200"
                        src="stripe_logo.png"
                    />

                    <v-row>
                        <v-col
                            v-if="$vuetify.breakpoint.smAndUp"
                            cols="4"
                            class="align-self-center"
                        >
                            <v-img
                                class="float-right"
                                width="200"
                                src="stripe_logo.png"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            sm="8"
                            :class="
                                $vuetify.breakpoint.smAndUp
                                    ? 'text-start'
                                    : 'text-center'
                            "
                        >
                            <div class="text-h4 font-weight-bold mb-3">
                                Powered by Stripe
                            </div>

                            <div class="text-body-1">
                                All payment data is handled directly by our
                                payment processor, Stripe, and never touches the
                                Musicologie software. We chose to partner with
                                Stripe for their incredible security and Level 1
                                PCI Compliance. Stripe processes payments for
                                thousands of companies like Lyft, Zoom and
                                Amazon.
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
                <div class="py-12"></div>
            </section>
        </v-main>

        <SiteFooter />
    </v-app>
</template>

<script>
import JetApplicationLogo from "./../Jetstream/ApplicationLogo";
import SiteFooter from "../Layouts/Components/SiteFooter.vue";

export default {
    components: {
        JetApplicationLogo,
        SiteFooter,
    },
    data: function () {
        return {
            features: [
                {
                    icon: "storefront",
                    title: "For Musicologie",
                    text: "We designed our software in-house for a seamless experience. ",
                },
                {
                    icon: "school",
                    title: "For Teachers",
                    text: "Manage your availability. Share lesson notes. Everything in one place.",
                },
                {
                    icon: "people",
                    title: "For Students",
                    text: "Easy rescheduling. Explore classes near you. Stay connected.",
                },
            ],
        };
    },
};
</script>

<style scoped></style>
